var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"loading"}},[_c('p',[_c('img',{attrs:{"src":require("@/assets/images/preloader.gif")}})]),_c('p',[_vm._v("Loading...")])])}]

export { render, staticRenderFns }